import { createEventTracker } from '../util';
import { JourneyMapViewedAnalytics, JourneyMapEventHidden, JourneyMapAnalytics } from './types';

export const trackJourneyMapViewed =
  createEventTracker<JourneyMapViewedAnalytics>('Journey Map Viewed');
export const trackJourneyMapSaved = createEventTracker<JourneyMapAnalytics>('Journey Map Saved');
export const trackJourneysEventExcluded =
  createEventTracker<JourneyMapEventHidden>('Journeys Event Hidden');
